// extracted by mini-css-extract-plugin
export default {"messageComponent":"MessageComponent_messageComponent__DfByF","messageComponentActive":"MessageComponent_messageComponentActive__iUtKG"};